export enum SignerQualityEnum {
  PROFESSIONAL = 'PROFESSIONAL',
  INDIVIDUAL = 'INDIVIDUAL'
}

export enum TitleEnum {
  MR = 'Monsieur',
  MME = 'Madame'
}

export enum AuthTypeEnum {
  EMAIL = 'mailOTP',
  SMS = 'smsOTP'
}

export enum TypeBounceEnum {
  EXPIRED = 'RESUME_EXPIRED',
  REFUSED = 'RESUME_REFUSED',
  FAILED = 'FAILED',
  DAY = 'DAY'
}
